import InviteApplicantsModal from "./InviteApplicantsModal";

export default InviteApplicantsModal;
